export default __webpack_public_path__ + "img/move-to-front.0fb82caf.svg";